import { useLayoutEffect } from "react";
import { useLocation } from "react-router";
import { ScrollTrigger } from "../animations/gsap";

// Jump (never glide) to the top: the site sets CSS `scroll-behavior: smooth`,
// and an in-flight smooth scroll would otherwise carry on after a route change.
function jumpToTop() {
  try {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  } catch (e) {
    // Older browsers reject "instant"; fall back to the classic call.
    window.scrollTo(0, 0);
  }
}

/**
 * Resets the scroll position on every route change.
 *
 * Rendered as a leaf *before* <Routes> so its layout effect runs before the
 * new page creates its scroll-triggered animations; otherwise ScrollTrigger
 * would measure (and restore) the previous page's scroll position.
 */
const ScrollToTop = () => {
  const location = useLocation();
  useLayoutEffect(() => {
    ScrollTrigger.clearScrollMemory();
    jumpToTop();
    // Once the browser has laid out the new page (and applied any scroll
    // anchoring against the persistent header/footer), jump again and then
    // re-measure every scroll-triggered animation.
    const id = window.requestAnimationFrame(() => {
      jumpToTop();
      ScrollTrigger.refresh();
    });
    return () => window.cancelAnimationFrame(id);
  }, [location]);

  return null;
};

export default ScrollToTop;
